<template>
  <div class="wrap">
    <div class="title">
      <h2>페이지순서 선택</h2>
      <div class="title-input">
        <p>* 학습자가 Access Code 입력하는 페이지에 노출되는 페이지 제목입니다.</p>
        <!-- <p v-if="isLoad" class="txt-red mb-10 mt-00">* 페이지는 페이지명만 수정이 가능하고, 페이지 순서 및 선택은 수정이 불가능합니다.</p> -->
        <p class="txt-red mt-00 font-15">* 해당 페이지는 한번 저장하신 후에는 페이지 순서 및 선택을 변경하실 수 없습니다.</p>
        <p class="txt-red  mt-00 font-15">* 교육비, 교재비가 0원 혹은 없는 경우, 수강신청 제작시 '결제 방식' 프로세스를 제외하고 생성 해야합니다.</p>
        <p class="txt-red mb-10 mt-00 font-15">* 학습자에게 메인 페이지에 노출되는 제목이니, 신중히 작성해주세요.</p>
        <input type="text" v-model="title" maxlength="30" placeholder="30자 이내로 입력해주세요." @keyup="checkTitle()" class="w-50per" />
      </div>
    </div>
    <div class="con mt-10">
      <div class="apply_templet">
        <ul>
          <!-- radio 버튼을 누르면 li class="on"으로 되도록 해주세요!  -->
          <li :class="{ on: pageType === 'one' }">
            <p>
              <input :disabled="isLoad" type="radio" id="test1" name="radio-group" value="one" v-model="pageType" checked />
              <label for="test1"></label>
            </p>
            <div class="templet-list">
              <ul>
                <li>신청 개요 / Access Code</li>
                <li>
                  <label for>
                    <input :disabled="isLoad" type="checkbox" v-model="aPage.agreeYn" true-value="Y" false-value="N" name id />
                    <span class="ml-10">신청 동의</span>
                  </label>
                </li>
                <li>
                  <label for>
                    <input :disabled="isLoad" type="checkbox" v-model="aPage.guideYn" true-value="Y" false-value="N" name id />
                    <span class="ml-10 bold txt-red">신청 안내</span>
                  </label>
                </li>
                <li>
                  <label for>
                    <input :disabled="isLoad" type="checkbox" v-model="aPage.chooseYn" true-value="Y" false-value="N" name id />
                    <span class="ml-10 bold txt-red">과정 선택</span>
                  </label>
                </li>
                <li class="bold txt-red">신청자 정보 입력</li>
                <li>
                  <label for>
                    <input :disabled="isLoad" type="checkbox" v-model="aPage.payYn" true-value="Y" false-value="N" name id />
                    <span class="ml-10">결제 방식</span>
                  </label>
                </li>
                <li>
                  <label for>
                    <input :disabled="isLoad" type="checkbox" v-model="aPage.completeYn" true-value="Y" false-value="N" name id />
                    <span class="ml-10">신청 완료</span>
                  </label>
                </li>
                <li>
                  <label for>
                    <input :disabled="isLoad" type="checkbox" v-model="aPage.popupYn" true-value="Y" false-value="N" name id />
                    <span class="ml-10">팝업 설정</span>
                  </label>
                </li>
              </ul>
            </div>
          </li>
          <li :class="{ on: pageType === 'two' }">
            <p>
              <input :disabled="isLoad" type="radio" id="test2" name="radio-group" value="two" v-model="pageType" />
              <label for="test2"></label>
            </p>
            <div class="templet-list">
              <ul>
                <li>신청 개요 / Access Code</li>
                <li>
                  <label for>
                    <input :disabled="isLoad" type="checkbox" v-model="bPage.agreeYn" true-value="Y" false-value="N" name id />
                    <span class="ml-10">신청 동의</span>
                  </label>
                </li>
                <li>
                  <label for>
                    <input :disabled="isLoad" type="checkbox" v-model="bPage.chooseYn" true-value="Y" false-value="N" name id />
                    <span class="ml-10 bold txt-red">과정 선택</span>
                  </label>
                </li>
                <li>
                  <label for>
                    <input :disabled="isLoad" type="checkbox" v-model="bPage.guideYn" true-value="Y" false-value="N" name id />
                    <span class="ml-10 bold txt-red">신청 안내</span>
                  </label>
                </li>
                <li class="bold txt-red">신청자 정보 입력</li>
                <li>
                  <label for>
                    <input :disabled="isLoad" type="checkbox" v-model="bPage.payYn" true-value="Y" false-value="N" name id />
                    <span class="ml-10">결제 방식</span>
                  </label>
                </li>
                <li>
                  <label for>
                    <input :disabled="isLoad" type="checkbox" v-model="bPage.completeYn" true-value="Y" false-value="N" name id />
                    <span class="ml-10">신청 완료</span>
                  </label>
                </li>
                <li>
                  <label for>
                    <input :disabled="isLoad" type="checkbox" v-model="bPage.popupYn" true-value="Y" false-value="N" name id />
                    <span class="ml-10">팝업 설정</span>
                  </label>
                </li>
              </ul>
            </div>
          </li>
          <li :class="{ on: pageType === 'three' }">
            <p>
              <input :disabled="isLoad" type="radio" value="three" v-model="pageType" id="test3" name="radio-group" />
              <label for="test3"></label>
            </p>
            <div class="templet-list">
              <ul>
                <li>신청 개요 / Access Code</li>
                <li>
                  <label for>
                    <input :disabled="isLoad" type="checkbox" v-model="cPage.agreeYn" true-value="Y" false-value="N" name id />
                    <span class="ml-10">신청 동의</span>
                  </label>
                </li>
                <li class="bold txt-red">신청자 정보 입력</li>
                <li>
                  <label for>
                    <input :disabled="isLoad" type="checkbox" v-model="cPage.guideYn" true-value="Y" false-value="N" name id />
                    <span class="ml-10 bold txt-red">신청 안내</span>
                  </label>
                </li>
                <li>
                  <label for>
                    <input :disabled="isLoad" type="checkbox" v-model="cPage.chooseYn" true-value="Y" false-value="N" name id />
                    <span class="ml-10 bold txt-red">과정 선택</span>
                  </label>
                </li>
                <li>
                  <label for>
                    <input :disabled="isLoad" type="checkbox" v-model="cPage.payYn" true-value="Y" false-value="N" name id />
                    <span class="ml-10">결제 방식</span>
                  </label>
                </li>
                <li>
                  <label for>
                    <input :disabled="isLoad" type="checkbox" v-model="cPage.completeYn" true-value="Y" false-value="N" name id />
                    <span class="ml-10">신청 완료</span>
                  </label>
                </li>
                <li>
                  <label for>
                    <input :disabled="isLoad" type="checkbox" v-model="cPage.popupYn" true-value="Y" false-value="N" name id />
                    <span class="ml-10">팝업 설정</span>
                  </label>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div>
      <button class="admin-btn-default button float-right mr-60" @click="next()">다음 페이지</button>
    </div>
  </div>
</template>

<script>
import { EmptyCheck } from "@/utils/validation.js";

export default {
  data: () => ({
    title: "",
    pageType: "one",
    pageIdx: -1,
    aPage: {
      // A타입 페이지
      agreeYn: "Y",
      category: "A",
      chooseYn: "Y",
      completeYn: "Y",
      guideYn: "Y",
      infoYn: "Y",
      payYn: "Y",
      popupYn: "Y",
      summaryYn: "Y",
    },
    bPage: {
      // B타입 페이지
      agreeYn: "Y",
      category: "B",
      chooseYn: "Y",
      completeYn: "Y",
      guideYn: "Y",
      infoYn: "Y",
      payYn: "Y",
      popupYn: "Y",
      summaryYn: "Y",
    },
    cPage: {
      // C타입 페이지
      agreeYn: "Y",
      category: "C",
      chooseYn: "Y",
      completeYn: "Y",
      guideYn: "Y",
      infoYn: "Y",
      payYn: "Y",
      popupYn: "Y",
      summaryYn: "Y",
    },

    isLoad: false, // 새 등록 페이지인지 불러오기 페이지인지 구분
  }),

  mounted() {
    console.log("fix", sessionStorage.getItem("fix"));

    if (sessionStorage.getItem("fix")) {
      // this.isLoad = true
      this.pageIdx = sessionStorage.getItem("pageIdx");
      this.axios.get(this.axios.root + this.axios.port + `/sugang/page/${this.pageIdx}`).then((res) => {
        console.log(`/sugang/page/${this.pageIdx}`, res);
        if (res.data.err === 0) {
          // alert('수정시에는 페이지 제목만 수정이 가능하고, 페이지 순서 및 선택은 수정이 불가능합니다.')
          alert("수강생이 존재하는 경우 페이지 순서 및 선택은 수정이 불가능합니다.");
          this.title = res.data.pageInfo.title;
          if (res.data.pageInfo.category === "A") {
            this.pageType = "one";
            this.aPage.agreeYn = res.data.pageInfo.agree_YN;
            this.aPage.chooseYn = res.data.pageInfo.choose_YN;
            this.aPage.completeYn = res.data.pageInfo.complete_YN;
            this.aPage.guideYn = res.data.pageInfo.guide_YN;
            this.aPage.infoYn = res.data.pageInfo.info_YN;
            this.aPage.payYn = res.data.pageInfo.pay_YN;
            this.aPage.popupYn = res.data.pageInfo.popup_YN;
            this.aPage.summaryYn = res.data.pageInfo.summary_YN;
          } else if (res.data.pageInfo.category === "B") {
            this.pageType = "two";
            this.bPage.agreeYn = res.data.pageInfo.agree_YN;
            this.bPage.chooseYn = res.data.pageInfo.choose_YN;
            this.bPage.completeYn = res.data.pageInfo.complete_YN;
            this.bPage.guideYn = res.data.pageInfo.guide_YN;
            this.bPage.infoYn = res.data.pageInfo.info_YN;
            this.bPage.payYn = res.data.pageInfo.pay_YN;
            this.bPage.popupYn = res.data.pageInfo.popup_YN;
            this.bPage.summaryYn = res.data.pageInfo.summary_YN;
          } else {
            this.pageType = "three";
            this.cPage.agreeYn = res.data.pageInfo.agree_YN;
            this.cPage.chooseYn = res.data.pageInfo.choose_YN;
            this.cPage.completeYn = res.data.pageInfo.complete_YN;
            this.cPage.guideYn = res.data.pageInfo.guide_YN;
            this.cPage.infoYn = res.data.pageInfo.info_YN;
            this.cPage.payYn = res.data.pageInfo.pay_YN;
            this.cPage.popupYn = res.data.pageInfo.popup_YN;
            this.cPage.summaryYn = res.data.pageInfo.summary_YN;
          }
        }
      });
    }
  },

  methods: {
    // 타이틀 30자 초과일때 alert
    checkTitle() {
      if (this.title.length > 30) {
        this.title = this.title.substring(0, 30);
        alert("페이지 제목은 30자 이내로 입력해주세요.");
        return false;
      }
    },
    // 다음 페이지 이동
    next() {
      if (!EmptyCheck(this.title, "페이지 제목을")) {
        return false;
      }

      var params = {};

      if (this.pageType === "one") {
        params = this.aPage;
      } else if (this.pageType === "two") {
        params = this.bPage;
      } else if (this.pageType === "three") {
        params = this.cPage;
      }

      if (params.payYn === "Y") {
        if (params.chooseYn === "N") {
          alert("결제 방식을 선택하시려면, 과정 선택이 필요합니다.");
          return false;
        }
      }

      var con_test = confirm("해당 페이지는 한번 저장하신 후에는\n페이지 순서 및 선택을 변경하실 수 없습니다.\n진행하시겠습니까?");
      if (con_test == true) {
      } else {
        return false;
      }

      //   this.setOrder(params);

      params.title = this.title;

      let pageIdx = sessionStorage.getItem("pageIdx");
      console.log("pageIdx!!!!!", pageIdx);
      if (sessionStorage.getItem("pageIdx")) {
        params["idx"] = sessionStorage.getItem("pageIdx");
        this.axios.put(this.axios.root + this.axios.port + "/sugang/page", params).then((res) => {
          console.log(res);
          if (res.data.status == 1) {
            this.$router.push("/admin/reg/input");
          } else {
            alert(res.data.result);
            return false;
          }
          // sessionStorage.setItem("category", params.category);
          // sessionStorage.setItem("pageIdx", res.data.pageIdx);
          // this.loadSugang(res.data.pageIdx);
          // sessionStorage.setItem("step", "input");
          // this.$router.push('/admin/reg/input')
        });
      } else {
        params["idx"] = this.pageIdx;
        this.axios.post(this.axios.root + this.axios.port + "/sugang/page", params).then((res) => {
          console.log(res);
          sessionStorage.setItem("category", params.category);
          sessionStorage.setItem("pageIdx", res.data.pageIdx);
          this.loadSugang(res.data.pageIdx);
          sessionStorage.setItem("step", "input");
          // this.$router.push('/admin/reg/input')
        });
      }

      // this.axios
      //     .post(this.axios.root + this.axios.port + "/sugang/page", params)
      //     .then((res) => {
      //         console.log(res);
      //         sessionStorage.setItem("category", params.category);
      //         sessionStorage.setItem("pageIdx", res.data.pageIdx);
      //         this.loadSugang(res.data.pageIdx);
      //         sessionStorage.setItem("step", "input");
      //         // this.$router.push('/admin/reg/input')
      //     });
    },

    // 수강신청 불러오기
    async loadSugang(pageIdx) {
      await this.axios.get(this.axios.root + this.axios.port + `/sugang/page/${pageIdx}`).then((res) => {
        console.log(res);
        if (res.data.err === 0) {
          var pOrder = [];
          for (var i = 1; i <= 8; i++) {
            for (var item of res.data.menu) {
              if (item.order === i.toString()) {
                if (item.status === "Y") {
                  if (item.name === "summary") {
                    pOrder.push("input");
                  } else if (item.name === "agree") {
                    pOrder.push("agree");
                  } else if (item.name === "guide") {
                    pOrder.push("info");
                  } else if (item.name === "choose") {
                    pOrder.push("enroll");
                  } else if (item.name === "info") {
                    pOrder.push("userInfo");
                  } else if (item.name === "pay") {
                    pOrder.push("purchase");
                  } else if (item.name === "complete") {
                    pOrder.push("complete");
                  } else if (item.name === "popup") {
                    pOrder.push("setPopup");
                  }
                }
              }
            }
          }

          sessionStorage.setItem("pOrder", JSON.stringify(pOrder));
          sessionStorage.setItem("category", res.data.pageInfo.category);
        }
      });
      await this.$router.push("/admin/reg/input");
    },

    // 카테고리에 따른 프로그레스 순서 정해주는 함수
    setOrder(params) {
      if (params.category === "A") {
        this.progressOrder = ["input", "agree", "info", "enroll", "userInfo", "purchase", "complete", "setPopup"];
      } else if (params.category === "B") {
        this.progressOrder = ["input", "agree", "enroll", "info", "userInfo", "purchase", "complete", "setPopup"];
      } else {
        this.progressOrder = ["input", "agree", "userInfo", "info", "enroll", "purchase", "complete", "setPopup"];
      }
      sessionStorage.setItem("pOrder", JSON.stringify(this.progressOrder));
    },
  },
};
</script>

<style scoped>
.active {
  background: whitesmoke;
}
</style>
